import handelCloudText from './handelCloudText';
import handelCopyText from './handelCopyText';
import handleNumberText from './handelNumberText';
import handleDateText from './handleDateText';
import handleTipsText from './handleTipsText';

/**
 * 自定义处理 UBB 文本
 * @param text
 * @returns
 */
export const customHandleUbbText = (text: string): string => {
    const cloudText = handelCloudText(text);
    const copyText = handelCopyText(cloudText);
    const numberText = handleNumberText(copyText);
    const dateText = handleDateText(numberText);
    const tipsText = handleTipsText(dateText);
    return tipsText;
};
